<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        学校別申し込み状況
      </template>

      <template v-slot:content>
        <v-row class="mb-0 pb-0">
          <v-col :cols="schoolCodeCols">
            <v-text-field
              v-model="schoolCode"
              label="学校コード"
              color="secondary"
              class="schoolcode-width"
            />
          </v-col>
          <v-col cols="2">
            <v-select
              v-model="selectedPrefectureCode"
              :items="prefectures"
              item-text="name"
              item-value="code"
              label="都道府県"
              clearable
              class="prefectres-width"
            ></v-select>
          </v-col>
          <v-col :offset="offsetCols" cols="3" class="d-flex" v-resize="setOffsetCols">
            <v-btn class="mt-5 ml-auto" small color="#4a81aa" dark @click.stop="downloadCsv">csvダウンロード</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="filterdSchools"
          :loading="loading"
          loading-text="Loading... Please wait"
          :options.sync="pagination"
          hide-default-footer
          :height="300"
        >
          <template #[`item.applications`]="{ item }">
            <v-btn small color="secondary" rounded dark @click.stop="showApplications(item)">確認</v-btn>
          </template>
        </v-data-table>
        <v-pagination v-model="pagination.page" :length="pages" color="secondary" />
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBaseCard,
  },
  data () {
    return {
      headers: [
        { text: '学校名', align: 'start', value: 'name' },
        { text: '学校コード', align: 'start', value: 'code' },
        { text: '都道府県', align: 'center', value: 'prefecture_name'},
        { text: '未処理件数', align: 'center', value: 'untreated_count'},
        { text: '内容確認中件数', align: 'center', value: 'processingd_count'},
        { text: '処理済み件数', align: 'center', value: 'treated_count'},
        { text: '申し込み一覧', align: 'center', value: 'applications', sortable: false },
      ],
      schools: [],
      selectedPrefectureCode: null,
      loading: false,
      pagination: {
        itemsPerPage: 5
      },
      schoolCode: null,
      schoolCodeCols: 2,
      offsetCols: 5
    }
  },

  async mounted() {
    await this.getSchools()
  },

  computed: {
    filterdSchools() {
      const schools = this.selectedPrefectureCode
        ? this.schools.filter(school => school.prefecture_code === this.selectedPrefectureCode)
        : this.schools
      return this.schoolCode
        ? schools.filter(school => school.code.indexOf(this.schoolCode) > -1)
        : schools
    },
    prefectures() {
      return this.$store.state.master.allPrefectures
    },
    pages() {
      return this.pagination.itemsPerPage ? Math.ceil(this.filterdSchools.length / this.pagination.itemsPerPage) : 0
    },
  },

  methods: {
    // 先生_お知らせ一覧取得API
    async getSchools() {
      this.loading = true
      const res = await this.$axios(`/api/v1/admin/schools?q[with_requests][]=untreated&q[with_requests][]=processing`)
      this.schools = res.data
      this.loading = false
    },
    // 先生_お知らせCSVダウンロードAPI
    async downloadCsv() {
      const prefecture_code = this.selectedPrefectureCode
        ? this.prefectures.find(pref => pref.code === this.selectedPrefectureCode).code
        : ''
      const params = `q[prefecture_code_eq]=${prefecture_code}&q[with_requests][]=untreated&q[with_requests][]=processing`
      const res = await this.$axios(`/api/v1/admin/schools.csv/?${params}`,{responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })

      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)

      saveAs(blob, fileName)
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')

      return fileName
    },
    showApplications(school) {
      this.$store.commit('school/setSchool', school)
      this.$router.push(`/admin/applications/${school.id}`)
    },
    setOffsetCols() {
      //「CSVダウンロード」ボタンがはみ出ないように、画面幅に応じてcolsを調整
      if(1080 <= window.innerWidth) this.offsetCols = 5
      else this.offsetCols = 4

      //学校コードのcolsも調整（ipad縦向きの場合、cols=2のままだと表示エリアが都道府県選択と被ってしまうため）
      if(this.offsetCols===4) this.schoolCodeCols = 3
      else this.schoolCodeCols = 2
    }
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size 11px !important
.csv_upload
  font-size 14px

.schoolcode-width
  min-width 100px //学校コード入力エリアの最小幅固定
.prefectres-width
  min-width 128px //都道府県選択エリアの最小幅固定
</style>
